<div class="card">
  <!-- header -->
  <header *ngIf="card.title">
    <ng-container [ngSwitch]="headingLevel">
      <h2 *ngSwitchCase="2">{{ card.title }}</h2>
      <h3 *ngSwitchCase="3">{{ card.title }}</h3>
      <h4 *ngSwitchDefault>{{ card.title }}</h4>
    </ng-container>
  </header>

  <div class="card-body">
    <!-- LIST CARDS -->
    <ul *ngIf="card.kind === 'list' && card.details?.length">
      <li *ngFor="let detail of card.details" [innerHTML]="detail.formatted | markdown">
      </li>
    </ul>

    <!-- TEXT CARDS -->
    <ng-container *ngIf="card.kind === 'text' && card.details?.length">
      <div *ngFor="let detail of card.details" [innerHTML]="detail.formatted | markdown">
      </div>
    </ng-container>

    <!-- PHARMACOLOGICAL CARDS -->
<ul *ngIf="card.kind === 'pharmacological' && card.details?.length">
  <li *ngFor="let detail of card.details">
    <span [innerHTML]="detail.treatment | markdown"></span>

    <ul *ngIf="detail.mechanism || detail.sideEffects">
      <li *ngIf="detail.mechanism">
        <i>Mechanism: </i> <span [innerHTML]="detail.mechanism | markdown"></span>
      </li>
      <li *ngIf="detail.sideEffects">
        <i>Side Effects: </i><span [innerHTML]="detail.sideEffects | markdown"></span>
      </li>
    </ul>
  </li>
</ul>




  </div>

  <footer *ngIf="footerTpl" class="card__footer">
    <ng-container *ngTemplateOutlet="footerTpl"></ng-container>
  </footer>
</div>
